import { render, staticRenderFns } from "./RestaurantContact.vue?vue&type=template&id=3f90a710&scoped=true&"
import script from "./RestaurantContact.vue?vue&type=script&lang=js&"
export * from "./RestaurantContact.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantContact.vue?vue&type=style&index=0&id=3f90a710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90a710",
  null
  
)

export default component.exports